import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import instructioncontent from "./instructioncontent";
import instructioncontentJeeMain from "./instructioncontentJeeMain";
import instructioncontentSsc from "./instructioncontentSsc";
import instructioncontentIpmat from "./instructioncontentIpmat";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getSlotListData } from "../../../../service/services";
import { getMarkListData } from "../../../../service/MarkingServices";
import { getCourseData } from "../../../../service/ExamServices";
import * as Yup from "yup";
import QuestionPickTable from "./QuestionPickTable";
import { sanitizeInput } from "../../../../Utils/validationUtils";

//scema of the form validation
// const examValidationSchema = Yup.object().shape({
//   exam_name: Yup.string().trim().required("Please enter an exam name."),
//   course_id: Yup.string().required("Please select a course."),
//   batch_id: Yup.string().required("Please select a batch."),
//   subjects: Yup.array().min(1, "Please select at least one subject."),
//   center_id: Yup.array().min(1, "Please select at least one center."),
//   language: Yup.array().min(1, "Please select at least one language."),
//   question_count: Yup.number()
//     .typeError("Please enter the number of questions.")
//     .required("Please enter the number of questions."),
//   total_score: Yup.number()
//     .typeError("Please enter the total score.")
//     .required("Please enter the total score."),
//   negative_marking: Yup.string(),
//   negative_marking_score: Yup.number().when("negative_marking", {
//     is: "yes",
//     then: (schema) =>
//       schema
//         .moreThan(0, "Please add a Negative Marking greater than 0.")
//         .required("Please add a Negative Marking."),
//     otherwise: (schema) => schema.notRequired(),
//   }),
//   exam_pin: Yup.string().required("Please enter the exam pin."),
//   duration: Yup.number()
//     .typeError("Please enter the duration of the exam.")
//     .required("Please enter the duration of the exam."),
//   start_date: Yup.string().required("Please select a start date."),
//   start_time: Yup.string().required("Please select a start time."),
//   exam_template: Yup.string().required("Please select an exam template."),
// });
// ReactQuill Modules and Formats
const quillModules = {
  toolbar: [
    [
      "bold",
      "italic",
      "underline",
      "strike",
      { script: "sub" },
      { script: "super" },
      { color: [] },
      { background: [] },
    ],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    ["code-block"],
  ],
};

const quillFormats = [
  "header",
  "font",
  "size",
  "list",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "link",
  "blockquote",
  "code-block",
  "align",
  "image",
];

// function for Convert Image In Base64

const convertImageToBase64 = async (url) => {
  const response = await axios.get(url, { responseType: "blob" });
  const blob = response.data;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

// Form InitialData
const initialData = {
  center_id: "",
  course_id: "",
  batch_id: "",
  exam_name: "",
  language: ["en"],
  question_count: "",
  total_score: "",
  question_shuffle: "no",
  option_shuffle: "no",
  negative_marking: "no",
  is_submit_on_time: "no",
  negative_marking_score: "0",
  exam_instant_result: "no",
  direction: "bidirectional",
  subject_selection: "no",
  exam_pin: "",
  exam_template: "ssc/railway",
  exam_format: "",
  exam_instructions: {
    en: "",
    hi: "",
  },
  genral_instruction: {
    en: "",
    hi: "",
  },
  duration: "",
  start_date: "",
  start_time: "",
  end_time: "",
  slot_value: "",
  marking_system: "",
  randomized_question_pick: "no",
  time_bound: "no",
  calculator_enable: "no",
  before_instruction: "yes",
  file: null,
  enable_submit: "0",
  section_count: [],
  center_feedback: "no",
  keyboard_enable: "yes",
};
// Menu Props for Fields
const menuProps = {
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  disablePortal: true,
};

function AddExamForm() {
  const classes = useStyles();
  const navigate = useNavigate();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [questionMarkSystem, setQuestionMarkSystem] = useState("same");
  const [formDetails, setFormDetails] = useState(initialData);
  const [examName, setExamName] = useState("");
  const [paperCode, setPaperCode] = useState("");
  const [perQuestionMarks, setPerQuestionMarks] = useState("0");
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [thumbnailImage, setThumbnailImage] = useState(null);
  const [showSubjectWiseDuration, setShowSubjectWiseDuration] = useState("yes");
  const [slotDropdownFieldData, setSlotDropdownFieldData] = useState([]);
  const [examTempalteData, setExamTemplateData] = useState([]);
  const [subjectDurations, setSubjectDurations] = useState([]);
  const [selectedSubjectName, setSelectedSubjectName] = useState([]);
  const [selectedSubjectSLength, setSelectedSubjectSLength] = useState(0);

  const [pinEnable, setPinEnable] = useState("off");

  // console.log('selectedCourse',selectedCourse)

  useEffect(() => {
    const convertAllImagesToBase64 = async (htmlContent) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      const imgTags = doc.querySelectorAll("img");

      for (const img of imgTags) {
        const src = img.getAttribute("src");
        if (src && !src.startsWith("data:")) {
          const base64 = await convertImageToBase64(src);
          img.setAttribute("src", base64);
        }
      }

      return doc.body.innerHTML;
    };
    const handleInstructions = async () => {
      if (!formDetails.exam_template) return;

      let selectedInstructions;
      switch (formDetails.exam_template.toLowerCase()) {
        case "iit":
          selectedInstructions = {
            en: instructioncontentJeeMain.en,
            hi: instructioncontentJeeMain.hi,
          };
          break;
        case "ssc/railway":
          selectedInstructions = {
            en: instructioncontentSsc.en,
            hi: instructioncontentSsc.hi,
          };
          break;
        case "ipmat":
          selectedInstructions = {
            en: instructioncontentIpmat.en,
            hi: instructioncontentIpmat.hi,
          };
          break;
        default:
          selectedInstructions = {
            en: instructioncontent.en,
            hi: instructioncontent.hi,
          };
      }

      const [en, hi] = await Promise.all([
        convertAllImagesToBase64(selectedInstructions.en),
        convertAllImagesToBase64(selectedInstructions.hi),
      ]);
      setFormDetails((prev) => ({
        ...prev,
        exam_instructions: { en, hi },
      }));
    };

    handleInstructions();
  }, [formDetails.exam_template]);

  useEffect(() => {
    const fetchSlots = async () => {
      if (!decryptedToken) return;

      try {
        // const [markListData, slotListData, courseData] = await Promise.all([
        //   getMarkListData(),
        //   getSlotListData(),
        //   getCourseData(),
        // ]);
        const res = await getCourseData();
        // setExamTemplateData(markListData?.markingsystem || []);
        // setSlotDropdownFieldData(slotListData || []);
        if (res?.courses) {
          setCourses(res?.courses || []);
        }
      } catch (err) {
        console.error("Failed to load slots:", err);
      }
    };
    fetchSlots();
  }, []);

  useEffect(() => {
    fetchCenter();

    fetchSubjects();

    if (selectedCourse) {
      fetchBatches(selectedCourse);
    }
  }, [selectedCourse, selectedBatch]);

  useEffect(() => {
    if (
      formDetails.time_bound === "yes" &&
      formDetails.start_time &&
      formDetails.duration
    ) {
      const [hours, minutes] = formDetails.start_time.split(":").map(Number);
      const durationMinutes = parseInt(formDetails.duration) || 0;

      const startDate = new Date();
      startDate.setHours(hours, minutes, 0, 0);

      const endDate = new Date(startDate.getTime() + durationMinutes * 60000);

      const endHours = String(endDate.getHours()).padStart(2, "0");
      const endMinutes = String(endDate.getMinutes()).padStart(2, "0");
      const calculatedEndTime = `${endHours}:${endMinutes}`;

      if (formDetails.end_time !== calculatedEndTime) {
        setFormDetails((prev) => ({
          ...prev,
          end_time: calculatedEndTime,
        }));
      }
    }
  }, [formDetails.time_bound, formDetails.start_time, formDetails.duration]);

  useEffect(() => {
    const qCount = Number(formDetails.question_count);
    const tScore = Number(formDetails.total_score);
    if (qCount > 0 && tScore > 0) {
      const calculated = tScore / qCount;
      setPerQuestionMarks(
        Number.isInteger(calculated) ? calculated.toString() : calculated.toFixed(2)
      );
    } else {
      setPerQuestionMarks("0");
    }
  }, [formDetails.question_count, formDetails.total_score]);

  //For Change The Subject Wise Duration Of Each Field
  const handleSubjectDurationChange = (subjectId, value) => {
    setSubjectDurations((prev) => {
      const existingIndex = (prev || []).findIndex(
        (item) => String(item.subject_id) === String(subjectId),
      );

      const parsedValue = value === "" ? "" : parseInt(value) || 0;

      if (existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          duration: parsedValue,
        };
        return updated;
      } else {
        return [
          ...(prev || []),
          { subject_id: subjectId, duration: parsedValue },
        ];
      }
    });
  };

  const handleLanguageMenuToggle = () => {
    setLanguageMenuOpen(!languageMenuOpen);
  };

  const handleFormChange = (fieldName, value) => {
    if (fieldName === "end_time") {
      if (formDetails.start_time && value && value <= formDetails.start_time) {
        toast.warn("End time must be after start time.");
        setFormDetails((prev) => ({
          ...prev,
          end_time: "",
        }));
        return;
      }
    }

    if (fieldName === "start_time") {
      if (formDetails.end_time && value && formDetails.end_time <= value) {
        toast.warn("Start time cannot be after end time. Please reselect end time.");
        setFormDetails((prev) => ({
          ...prev,
          start_time: value,
          end_time: "",
        }));
        return;
      }
    }

    const updatedForm = {
      ...formDetails,
      [fieldName]:
        fieldName === "language" && typeof value === "string"
          ? value.split(",")
          : value,
    };
    if (updatedForm.question_count && updatedForm.total_score) {
      const qCount = Number(updatedForm.question_count);
      const tScore = Number(updatedForm.total_score);
      if (qCount > 0 && tScore > 0) {
        const calculated = tScore / qCount;
        setPerQuestionMarks(
          Number.isInteger(calculated) ? calculated.toString() : calculated.toFixed(2)
        );
      }
    }
    if (fieldName === "language") {
      const languages = updatedForm.language;
      const newInstructions = { ...formDetails.exam_instructions };
      const newGeneralInstructions = { ...formDetails.genral_instruction };
      languages.forEach((lang) => {
        if (!newInstructions[lang]) {
          newInstructions[lang] = "";
        }
        if (!newGeneralInstructions[lang]) {
          newGeneralInstructions[lang] = "";
        }
      });
      setFormDetails((prev) => ({
        ...prev,
        [fieldName]: languages,
        exam_instructions: newInstructions,
        genral_instruction: newGeneralInstructions,
      }));
    } else {
      setFormDetails((prev) => {
        const newForm = { ...prev, [fieldName]: value };
        if (fieldName === "question_mark_system" && value === "different") {
          newForm.negative_marking = "no";
        }
        if (fieldName === "exam_template" && value !== "ssc/railway") {
          newForm.exam_format = "";
        }
        return newForm;
      });
    }
  };

  const handleExamFormatChange = (format) => {
    let autofillData = null;

    if (format === "NEET") {
      autofillData = {
        question_count: "180",
        total_score: "720",
        questionMarkSystem: "same",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Mains") {
      autofillData = {
        question_count: "75",
        total_score: "300",
        questionMarkSystem: "same",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Advance(48)") {
      autofillData = {
        question_count: "48",
        total_score: "180",
        questionMarkSystem: "different",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Advance(51)") {
      autofillData = {
        question_count: "51",
        total_score: "180",
        questionMarkSystem: "different",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Advance(54)") {
      autofillData = {
        question_count: "54",
        total_score: "180",
        questionMarkSystem: "different",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    } else if (format === "JEE Advance(57)") {
      autofillData = {
        question_count: "57",
        total_score: "180",
        questionMarkSystem: "different",
        negative_marking: "yes",
        negative_marking_score: "1",
      };
    }

    if (autofillData) {
      setQuestionMarkSystem(autofillData.questionMarkSystem);
      const calculated =
        Number(autofillData.total_score) / Number(autofillData.question_count);
      setPerQuestionMarks(calculated.toFixed(2));

      setFormDetails((prev) => ({
        ...prev,
        exam_format: format,
        question_count: autofillData.question_count,
        total_score: autofillData.total_score,
        negative_marking: autofillData.negative_marking,
        negative_marking_score: autofillData.negative_marking_score,
      }));
    } else {
      handleFormChange("exam_format", format || "");
    }
  };

  const handleQuestionMarkSystemChange = (event) => {
    setShowSubjectWiseDuration(event.target.value);
  };

  // const handleQuestionMarkSystemChange = (event) => {
  //   setShowSubjectWiseDuration(event.target.value);
  // };

  const handleCourceChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  const handleBatchChange = (event) => {
    setSelectedBatch(event.target.value);
  };

  const handleSubjectChange = (event, newValue) => {
    const selectedIds = newValue.map((subject) => subject.id);
    setSelectedSubject(selectedIds);
    setSelectedSubjectName(newValue.map((subject) => subject));
    setSubjectDurations((prev) =>
      (prev || []).filter((item) =>
        selectedIds.some((id) => String(id) === String(item.subject_id))
      )
    );
  };

  const handleCenterChange = (event, newValue) => {
    setSelectedCenter(newValue.map((center) => center.id));
  };

  const handleCancel = () => {
    navigate("/admin/exam");
  };

  function isDecimal(num) {
    const decimal = num % 1;
    return decimal !== 0;
  }

  const validateSectionWiseCount = (sectionWiseCount) => {
    if (sectionWiseCount.length !== selectedSubjectSLength) {
      toast.warning("Please enter Question Count for all sections.");
      return true;
    }

    let totalQuestionSum = 0;
    let pickQuestionSum = 0;

    for (let item of sectionWiseCount) {
      if (
        item.total_question_count === "" ||
        item.total_question_count === undefined
      ) {
        toast.warning("Please enter Total Question Count for all sections.");
        return true;
      }

      if (
        item.pick_question_count === "" ||
        item.pick_question_count === undefined
      ) {
        toast.warning("Please enter Pick Question Count for all sections.");
        return true;
      }

      if (item.pick_question_count > item.total_question_count) {
        toast.warning(
          "Pick Question Count cannot be greater than Total Question Count.",
        );
        return true;
      }

      totalQuestionSum += Number(item.total_question_count);
      pickQuestionSum += Number(item.pick_question_count);
    }
    console.log(
      "totalQuestionSum !== Number(formDetails.total_question",
      totalQuestionSum,
      Number(formDetails.total_question),
    );
    if (totalQuestionSum !== Number(formDetails.total_question)) {
      toast.warning(
        "Total Question of all sections must equal Total Question Count.",
      );
      return true;
    }

    if (pickQuestionSum !== Number(formDetails.question_count)) {
      toast.warning(
        "Pick Question of all sections must equal Pick Question Count.",
      );
      return true;
    }

    return false;
  };

  const handleFormSubmit = async () => {
    if (!examName.trim()) {
      toast.warn("Please enter an exam name.");
      return;
    }

    if (!selectedCourse) {
      toast.warn("Please select a course.");
      return;
    }

    if (!selectedBatch || selectedBatch.length === 0 || batches?.length === 0) {
      toast.warn("Please select a batch.");
      return;
    }

    if (
      !selectedSubject ||
      selectedSubject.length === 0 ||
      subjects?.length === 0
    ) {
      toast.warn("Please select at least one subject.");
      return;
    }

    if (!selectedCenter || selectedCenter.length === 0) {
      toast.warn("Please select at least one center.");
      return;
    }

    if (!formDetails.language || formDetails.language.length === 0) {
      toast.warn("Please select at least one language.");
      return;
    }

    if (!formDetails?.question_count) {
      toast.warn(
        `Please enter the ${formDetails?.randomized_question_pick === "yes"
          ? "number of pick questions."
          : "number of questions."
        }`,
      );
      return;
    }

    if (
      formDetails?.randomized_question_pick === "yes" &&
      !formDetails.total_question
    ) {
      toast.warn(`Please enter the number of total question count`);
      return;
    }

    // 🔍 Subject-wise Question Count VALIDATION
    if (
      formDetails.randomized_question_pick === "yes" &&
      formDetails.exam_template === "default"
    ) {
      const subjectCounts = formDetails.subject_question_count || [];
      const selectedSubjectsList = selectedSubjectName || [];

      // 1️⃣ Validate each subject count
      for (const sub of selectedSubjectsList) {
        const record = subjectCounts.find((item) => item.subject_id === sub.id);

        if (!record || !record.count || Number(record.count) <= 0) {
          toast.warn(
            `Please enter valid question count for ${sub.subject_name}.`,
          );
          return;
        }
      }

      // 2️⃣ Calculate total
      const totalFromSubjects = subjectCounts
        .map((item) => Number(item.count))
        .reduce((acc, n) => acc + n, 0);

      if (totalFromSubjects !== Number(formDetails.question_count)) {
        toast.warn(
          `Total subject-wise question count (${totalFromSubjects}) must match Question Count (${formDetails.question_count}).`,
        );
        return;
      }
    }

    if (
      formDetails.randomized_question_pick === "yes" &&
      (formDetails.exam_template === "ssc/railway" ||
        formDetails.exam_template === "ipmat") &&
      validateSectionWiseCount(formDetails?.section_count)
    ) {
      return;
    }

    if (!formDetails.total_score) {
      toast.warn("Please enter the total score.");
      return;
    }
    if (
      showSubjectWiseDuration === "yes" &&
      formDetails.exam_template === "ipmat"
    ) {
      const activeDurations = (subjectDurations || []).filter((item) =>
        selectedSubject.some((subId) => String(subId) === String(item.subject_id))
      );

      // Check if durations are provided for all selected subjects
      const missingOrInvalidSubjects = [];
      selectedSubject.forEach((subId) => {
        const item = activeDurations.find(
          (d) => String(d.subject_id) === String(subId)
        );
        const subject = subjects.find((sub) => String(sub.id) === String(subId));
        const subjectName = subject ? subject.subject_name : "Subject";

        if (!item || item.duration === "" || item.duration === undefined || item.duration === null || isNaN(item.duration) || Number(item.duration) <= 0) {
          missingOrInvalidSubjects.push(subjectName);
        }
      });

      if (missingOrInvalidSubjects.length > 0) {
        toast.warn(
          `Please enter valid duration for all selected subjects: ${missingOrInvalidSubjects.join(", ")}`,
        );
        return;
      }
    }
    if (
      formDetails.negative_marking == "yes" &&
      (formDetails.negative_marking_score.length === 0 ||
        formDetails.negative_marking_score == -0)
    ) {
      if (formDetails.negative_marking_score == -0) {
        toast.warn("Please Add a Negetive Marking Grater Then 0.");
      } else {
        toast.warn("Please Add a Negetive Marking.");
      }
      return;
    }
    if (!formDetails.exam_pin && pinEnable === "on") {
      toast.warn("Please enter the exam pin.");
      return;
    }

    if (!formDetails.duration) {
      toast.warn("Please enter the duration of the exam.");
      return;
    }

    if (!formDetails.start_date) {
      toast.warn("Please select a start date.");
      return;
    }

    if (!formDetails.start_time) {
      toast.warn("Please select a start time.");
      return;
    }
    if (!formDetails.end_time) {
      toast.warn("Please select a end time.");
      return;
    }
    if (formDetails.end_time <= formDetails.start_time) {
      toast.warn("End time must be after start time.");
      return;
    }
    if (!formDetails.exam_template) {
      toast.warn("Please select a Exam Template.");
      return;
    }
    if (
      formDetails.exam_template === "ssc/railway" &&
      !formDetails.exam_format
    ) {
      toast.warn("Please select an Exam Format.");
      return;
    }
    // if (!formDetails.slot_value) {
    //   toast.warn("Please select a Slot.");
    //   return;
    // }
    // if (formDetails.negative_marking_score.length == 0) {
    //   toast.warn("Please Add a Negative Marking.");
    //   return;
    // }


    if (questionMarkSystem === "same" && isDecimal(perQuestionMarks)) {
      toast.warn("Per Question Mark must be a whole number");
      return;
    }

    try {
      const formData = new FormData();
      const examData = {
        course_ids: selectedCourse,
        batch_ids: selectedBatch,
        subjects: selectedSubject,
        center_id: selectedCenter,
        exam_name: examName,
        paper_code: paperCode,
        language: formDetails.language.map((lang) =>
          lang === "en" ? "en" : "hi",
        ),
        question_count: formDetails.question_count,
        total_score: formDetails.total_score,
        per_question_mark: perQuestionMarks,
        randomized_question_pick: formDetails.randomized_question_pick,
        question_shuffle: formDetails.question_shuffle,
        subject_selection: formDetails.subject_selection,
        direction: formDetails.direction,
        option_shuffle: formDetails.option_shuffle,
        negative_marking: formDetails.negative_marking,
        negative_marking_score:
          formDetails.negative_marking === "no"
            ? "0"
            : `-${Math.abs(formDetails.negative_marking_score)}`,
        exam_instant_result: formDetails.exam_instant_result,
        exam_pin: formDetails.exam_pin,
        exam_instruction_en: formDetails.exam_instructions.en,
        exam_instruction_hi: formDetails.exam_instructions.hi,
        genral_instruction_en: formDetails.genral_instruction.en,
        genral_instruction_hi: formDetails.genral_instruction.hi,
        duration: formDetails.duration,
        enable_submit: formDetails.enable_submit || "0",
        start_date: formDetails.start_date,
        start_time: formDetails.start_time,
        end_time: formDetails.end_time,
        exam_template: formDetails.exam_template,
        exam_format:
          formDetails.exam_template === "ssc/railway"
            ? formDetails.exam_format
            : null,
        is_submit_on_time: formDetails.is_submit_on_time,
        question_mark_system: questionMarkSystem,
        marking_system_id: formDetails.marking_system || null,
        subject_wise: showSubjectWiseDuration || null,
        slot_id: formDetails.slot_value || null,
        subjectDuration:
          showSubjectWiseDuration === "yes"
            ? (subjectDurations || []).filter((item) =>
              selectedSubject.some(
                (subId) => String(subId) === String(item.subject_id)
              )
            )
            : [],
        exam_type: "main",
        pin_enable: pinEnable,
        time_bound: formDetails.time_bound,
        calculator_enable: formDetails.calculator_enable,
        before_instruction: formDetails.before_instruction,
        count: formDetails.subject_question_count,
        section_count: formDetails.section_count,
        total_question: formDetails.total_question,
        center_feedback: formDetails.center_feedback,
        keyboard_enable: formDetails.keyboard_enable === "yes" || formDetails.keyboard_enable === true,
      };
      console.log(examData, "CheckExamData");
      formData.append("exam", JSON.stringify(examData));
      formData.append("file", thumbnailImage);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/add`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        toast.success("Exam created successfully!");
        setTimeout(() => {
          navigate(`/admin/addquestion/${response.data.exam.id}`);
        }, 2000);
      } else {
        // If the response status is not 200, handle it as an error
        toast.error(`Exam is not created! ${response.data.message}`);
      }
    } catch (error) {
      // Handling errors
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        // Display the error message from the API response
        toast.error(`Error: ${error.response.data.message}`);
      } else {
        // Generic error message for other types of errors
        toast.error("An unexpected error occurred while creating the exam.");
      }
      console.error("An error occurred:", error);
    }
  };

  const fetchBatches = async (selectedCourse) => {
    const data = {
      batch: {
        course_ids: selectedCourse,
      },
    };

    try {
      const response = await axios.post(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_id/${selectedCourse}`,
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/batch/by_course_ids/list`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      if (response) {
        console.log("selectedCourse", response.data.batches);
        setBatches(response.data.batches);
      } else {
        console.error("Failed to fetch batches data:", response);
      }

      // if (response.data && response.data.batches) {
      //   setBatches(response.data.batches);
      // } else {
      //   console.error("Invalid API response format:", response);
      // }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const fetchSubjects = async (selectedBatch) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject/active/list`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      if (response.data && response.data.subjects) {
        const filteredSubjects = (response.data.subjects || []).filter(
          (sub) => sub.type === "subject"
        );
        // setSubjects(response.data.subjects);
        setSubjects(filteredSubjects);
      } else {
        console.error("Invalid API response format:", response);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const fetchCenter = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      if (selectedCourse && selectedBatch) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course/batch/new`,
          {
            center: {
              courseId: selectedCourse,
              batchId: selectedBatch,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        setCenter(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  const [loading, setLoading] = useState(false);

  const handleAutoGeneratePin = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/generate/unique/pin`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      handleFormChange("exam_pin", res.data?.exam_pin);
    } catch (error) {
      console.error(error);
      toast.error("Failed to generate exam pin");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1}  ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h72vh}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Exam Details
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Name <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  required
                  onChange={(e) =>
                    setExamName(sanitizeInput(e.target.value, "textInput"))
                  }
                  value={examName}
                  placeholder="Type Here"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Paper Code
                </FormLabel>
                <TextField
                  type="text"
                  variant="outlined"
                  required
                  onChange={(e) =>
                    setPaperCode(sanitizeInput(e.target.value, "textInput"))
                  }
                  value={paperCode}
                  placeholder="Type Here"
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="courses-multiple"
                  options={courses}
                  getOptionLabel={(option) => option.course_name}
                  value={courses.filter((c) => selectedCourse.includes(c.id))}
                  onChange={(event, newValue) =>
                    setSelectedCourse(newValue.map((c) => c.id))
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="courses"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Batch <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  {selectedCourse?.length > 0 && batches?.length > 0 && (
                    <Button
                      size="small"
                      color="primary"
                      style={{ textTransform: "none", fontSize: "12px", padding: "0 4px", minWidth: "auto" }}
                      onClick={() => {
                        if (Array.isArray(selectedBatch) && selectedBatch.length === batches.length) {
                          setSelectedBatch([]);
                        } else {
                          setSelectedBatch(batches.map((bat) => bat.id));
                        }
                      }}
                    >
                      {Array.isArray(selectedBatch) && selectedBatch.length === batches.length
                        ? "Deselect All"
                        : "Select All"}
                    </Button>
                  )}
                </div>

                <Autocomplete
                  multiple
                  id="batches-multiple"
                  options={batches}
                  getOptionLabel={(option) => option.batch_name}
                  value={batches.filter((b) => selectedBatch.includes(b.id))}
                  onChange={(event, newValue) =>
                    setSelectedBatch(newValue.map((b) => b.id))
                  }
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="batches"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Subject <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={subjects}
                  getOptionLabel={(option) => option.subject_name}
                  value={subjects.filter((sub) =>
                    selectedSubject.includes(sub.id),
                  )}
                  onChange={handleSubjectChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
               ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch Code <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={center}
                  getOptionLabel={(option) =>
                    `${option.center_code} - ${option.center_name}`
                  }
                  value={center?.filter((sub) =>
                    selectedCenter?.includes(sub.id),
                  )}
                  onChange={handleCenterChange}
                  disableClearable
                  forcePopupIcon={false}
                  renderInput={(params) => (
                    <TextField
                      name="section"
                      type="text"
                      variant="outlined"
                      placeholder="Type to pick..."
                      {...params}
                    />
                  )}
                />
              </div>
            </div>

            {/* ── Subject Durations (IP MAT only) ── */}
            {formDetails.exam_template === "ipmat" &&
              selectedSubject?.length > 0 && (
                <div
                  className={`${classes.dflex} ${classes.w100} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexwrapwrap} ${classes.w75} ${classes.gap10}`}
                  >
                    {subjects
                      .filter((sub) => selectedSubject.includes(sub.id))
                      .map((sub) => (
                        <div
                          key={sub.id}
                          className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w32}`}
                        >
                          <FormLabel
                            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                          >
                            {sub.subject_name} Duration{" "}
                            <span className={classes.textcolorred}>*</span>
                          </FormLabel>
                          <TextField
                            type="number"
                            variant="outlined"
                            value={
                              subjectDurations?.find(
                                (item) =>
                                  String(item.subject_id) === String(sub.id),
                              )?.duration ?? ""
                            }
                            onChange={(e) =>
                              handleSubjectDurationChange(
                                sub.id,
                                e.target.value,
                              )
                            }
                            placeholder="Type Here"
                          />
                        </div>
                      ))}
                  </div>
                </div>
              )}

            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Languages <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="language-label"
                  id="language"
                  multiple
                  open={languageMenuOpen}
                  onOpen={handleLanguageMenuToggle}
                  onClose={handleLanguageMenuToggle}
                  value={formDetails.language}
                  onChange={(e) => {
                    handleFormChange("language", e.target.value);
                    handleLanguageMenuToggle(); // Close the dropdown after selection
                  }}
                  renderValue={(selected) =>
                    selected
                      .map((code) => (code === "en" ? "English" : "Hindi"))
                      .join(", ")
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem value="hi">Hindi</MenuItem>
                  <MenuItem value="en">English</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Pannel Template <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <Select
                  labelId="category-label"
                  id="state"
                  required
                  value={formDetails.exam_template}
                  onChange={(e) =>
                    handleFormChange("exam_template", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>

                  {/* <MenuItem value={"default"}>Default</MenuItem> */}
                  <MenuItem value={"ssc/railway"}>IIT</MenuItem>
                  <MenuItem value={"ipmat"}>IP MAT</MenuItem>
                  {/* <MenuItem value={"coding"}>Coding</MenuItem> */}
                  {/* <MenuItem value={"cat"}>Banking</MenuItem> */}
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                {formDetails.exam_template === "ssc/railway" && (
                  <>
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Exam Format <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Autocomplete
                      id="exam-format-autocomplete"
                      options={["NEET", "JEE Mains", "JEE Advance(48)", "JEE Advance(51)", "JEE Advance(54)", "JEE Advance(57)", "Other"]}
                      value={formDetails.exam_format || null}
                      onChange={(event, newValue) => {
                        handleExamFormatChange(newValue || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select Format"
                        />
                      )}
                    />
                  </>
                )}
                {formDetails.exam_template === "ipmat" && (
                  <>
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Randomized Question Pick{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="randomized-pick-label"
                      id="randomized-pick"
                      value={formDetails.randomized_question_pick || ""}
                      onChange={(e) =>
                        handleFormChange(
                          "randomized_question_pick",
                          e.target.value,
                        )
                      }
                      displayEmpty
                      required
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                      <MenuItem value="no">No</MenuItem>
                    </Select>
                  </>
                )}
              </div>
            </div>
            {/* ── IIT (ssc/railway) Fields ── */}
            {formDetails.exam_template === "ssc/railway" && (
              <>
                {/* IIT Row 4: Question Count | Total Score | Per Question Mark */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Question Count <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      onChange={(e) =>
                        handleFormChange("question_count", e.target.value)
                      }
                      value={formDetails.question_count}
                      placeholder="Type Here"
                    />
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Total Score <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      onChange={(e) =>
                        handleFormChange("total_score", e.target.value)
                      }
                      value={formDetails.total_score}
                      placeholder="Type Here"
                    />
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Per Question Mark
                    </FormLabel>
                    <TextField
                      type="text"
                      variant="outlined"
                      value={
                        perQuestionMarks ? `${perQuestionMarks} marks` : "N/A"
                      }
                      disabled
                    />
                  </div>
                </div>

                {/* IIT Row 5: Question Mark System | Negative Marking | Negative Marking Score */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Question Mark System <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={questionMarkSystem}
                      onChange={(e) => {
                        handleFormChange("question_mark_system", e.target.value);
                        setQuestionMarkSystem(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="same"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("same")}
                          />
                        }
                        label="Same"
                      />
                      <FormControlLabel
                        value="different"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("different")}
                          />
                        }
                        label="Different"
                      />
                    </RadioGroup>
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Negative Marking <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="negativemarking-label"
                      id="negativemarking"
                      value={
                        questionMarkSystem === "different"
                          ? "no"
                          : formDetails.negative_marking
                      }
                      onChange={(e) =>
                        handleFormChange("negative_marking", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                      disabled={questionMarkSystem === "different"}
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>
                      <MenuItem value={"yes"}>Yes</MenuItem>
                      <MenuItem value={"no"}>No</MenuItem>
                    </Select>
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Negative Marking Score <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="text"
                      variant="outlined"
                      required
                      value={
                        questionMarkSystem === "different" ||
                          formDetails.negative_marking === "no"
                          ? 0
                          : `-${String(
                            formDetails.negative_marking_score,
                          ).replace(/^[-]+/, "")}`
                      }
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9.]/g, "");
                        if (formDetails.negative_marking === "yes") {
                          handleFormChange("negative_marking_score", value);
                        } else {
                          handleFormChange("negative_marking_score", "0");
                        }
                      }}
                      placeholder="Type Here"
                      disabled={
                        questionMarkSystem === "different" ||
                        formDetails.negative_marking === "no"
                      }
                    />
                  </div>
                </div>
              </>
            )}

            {/* ── IPMat Fields ── */}
            {formDetails.exam_template === "ipmat" && (
              <>
                {/* IPMat Row 4:
                    if Randomized Question Pick == yes: Question Pick Count | Total Question Count | Total Score
                    if Randomized Question Pick == no: Question Count | Total Score | Per Question Mark */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  {formDetails.randomized_question_pick === "yes" ? (
                    <>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Question Pick Count <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("question_count", e.target.value)
                          }
                          value={formDetails.question_count}
                          placeholder="Type Here"
                        />
                      </div>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Total Question Count <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("total_question", e.target.value)
                          }
                          value={formDetails.total_question}
                          placeholder="Type Here"
                        />
                      </div>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Total Score <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("total_score", e.target.value)
                          }
                          value={formDetails.total_score}
                          placeholder="Type Here"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Question Count <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("question_count", e.target.value)
                          }
                          value={formDetails.question_count}
                          placeholder="Type Here"
                        />
                      </div>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Total Score <span className={classes.textcolorred}>*</span>
                        </FormLabel>
                        <TextField
                          type="number"
                          variant="outlined"
                          onChange={(e) =>
                            handleFormChange("total_score", e.target.value)
                          }
                          value={formDetails.total_score}
                          placeholder="Type Here"
                        />
                      </div>
                      <div
                        className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                      >
                        <FormLabel
                          className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                        >
                          Per Question Mark
                        </FormLabel>
                        <TextField
                          type="text"
                          variant="outlined"
                          value={
                            perQuestionMarks ? `${perQuestionMarks} marks` : "N/A"
                          }
                          disabled
                        />
                      </div>
                    </>
                  )}
                </div>

                {/* Extra row for Per Question Mark when Randomized Question Pick is yes */}
                {formDetails.randomized_question_pick === "yes" && (
                  <div
                    className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                  >
                    <Typography
                      className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                      variant="h6"
                      display="inline"
                    ></Typography>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                    >
                      <FormLabel
                        className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                      >
                        Per Question Mark
                      </FormLabel>
                      <TextField
                        type="text"
                        variant="outlined"
                        value={
                          perQuestionMarks ? `${perQuestionMarks} marks` : "N/A"
                        }
                        disabled
                      />
                    </div>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                    ></div>
                    <div
                      className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                    ></div>
                  </div>
                )}

                {/* IPMat Row 5: Question Mark System | Negative Marking | Negative Marking Score */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Question Mark System <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={questionMarkSystem}
                      onChange={(e) => {
                        handleFormChange("question_mark_system", e.target.value);
                        setQuestionMarkSystem(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="same"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("same")}
                          />
                        }
                        label="Same"
                      />
                      <FormControlLabel
                        value="different"
                        control={
                          <Radio
                            onClick={() => setQuestionMarkSystem("different")}
                          />
                        }
                        label="Different"
                      />
                    </RadioGroup>
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Negative Marking <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="ipmat-negativemarking-label"
                      id="ipmat-negativemarking"
                      value={
                        questionMarkSystem === "different"
                          ? "no"
                          : formDetails.negative_marking
                      }
                      onChange={(e) =>
                        handleFormChange("negative_marking", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                      disabled={questionMarkSystem === "different"}
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>
                      <MenuItem value={"yes"}>Yes</MenuItem>
                      <MenuItem value={"no"}>No</MenuItem>
                    </Select>
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Negative Marking Score <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="text"
                      variant="outlined"
                      required
                      value={
                        questionMarkSystem === "different" ||
                          formDetails.negative_marking === "no"
                          ? 0
                          : `-${String(
                            formDetails.negative_marking_score,
                          ).replace(/^[-]+/, "")}`
                      }
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^0-9.]/g, "");
                        if (formDetails.negative_marking === "yes") {
                          handleFormChange("negative_marking_score", value);
                        } else {
                          handleFormChange("negative_marking_score", "0");
                        }
                      }}
                      placeholder="Type Here"
                      disabled={
                        questionMarkSystem === "different" ||
                        formDetails.negative_marking === "no"
                      }
                    />
                  </div>
                </div>
              </>
            )}
          </div>

          {/* ── Section 2: Other Details ── */}
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            {/* Row 1: Question Shuffle | Option Shuffle | Time Bound */}
            <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Exam Features
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Question Shuffle <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="question-shuffle-label"
                  id="question-shuffle"
                  value={formDetails.question_shuffle}
                  onChange={(e) =>
                    handleFormChange("question_shuffle", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Option Shuffle <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="option-shuffle-label"
                  id="option-shuffle"
                  value={formDetails.option_shuffle}
                  onChange={(e) =>
                    handleFormChange("option_shuffle", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Time Bound <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="time-bound-label"
                  id="time_bound"
                  value={formDetails.time_bound}
                  onChange={(e) =>
                    handleFormChange("time_bound", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>
            </div>

            {/* Row 2: Calculator Enable | Keyboard Enable | Center Feedback */}
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Calculator Enable <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="calculator-enable-label"
                  id="calculator-enable"
                  value={formDetails.calculator_enable}
                  onChange={(e) =>
                    handleFormChange("calculator_enable", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect} style={{ opacity: 0.4 }}>
                      Select Here
                    </em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Keyboard Enable <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="keyboard-enable-label"
                  id="keyboard-enable"
                  value={formDetails.keyboard_enable || "yes"}
                  onChange={(e) =>
                    handleFormChange("keyboard_enable", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Center Feedback <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Autocomplete
                  id="center-feedback-autocomplete"
                  options={["yes", "no"]}
                  getOptionLabel={(option) =>
                    option.charAt(0).toUpperCase() + option.slice(1)
                  }
                  value={formDetails.center_feedback || "no"}
                  onChange={(event, newValue) => {
                    handleFormChange("center_feedback", newValue || "no");
                  }}
                  disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="center_feedback"
                      variant="outlined"
                      placeholder="Select Here"
                    />
                  )}
                />
              </div>
            </div>

            {/* Row 3: Exam Instant Result | Exam Instructions before | Exam PIN (in 1 col) */}
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Instant Result <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="exam-instant-result-label"
                  id="exam-instant-result"
                  value={formDetails.exam_instant_result}
                  onChange={(e) =>
                    handleFormChange("exam_instant_result", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                  <MenuItem value={"with_answer"}>With Answers</MenuItem>
                  <MenuItem value={"without_answer"}>Without Answers</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Exam Instructions before{" "}
                  <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="before-instruction-label"
                  id="before-instruction"
                  value={formDetails.before_instruction}
                  onChange={(e) =>
                    handleFormChange("before_instruction", e.target.value)
                  }
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect} style={{ opacity: 0.4 }}>
                      Select Here
                    </em>
                  </MenuItem>
                  <MenuItem value={"yes"}>Yes</MenuItem>
                  <MenuItem value={"no"}>No</MenuItem>
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    minHeight: "24px",
                  }}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Exam PIN{" "}
                    {pinEnable === "on" && (
                      <span className={classes.textcolorred}>*</span>
                    )}
                  </FormLabel>
                  <RadioGroup
                    row
                    value={pinEnable}
                    onChange={(e) => setPinEnable(e.target.value)}
                    className={classes.radiocolor}
                  >
                    <FormControlLabel
                      value="on"
                      control={<Radio size="small" />}
                      label="On"
                      style={{ marginRight: 6 }}
                    />
                    <FormControlLabel
                      value="off"
                      control={<Radio size="small" />}
                      label="Off"
                      style={{ margin: 0 }}
                    />
                  </RadioGroup>
                </div>
                {pinEnable === "on" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <TextField
                      type="text"
                      variant="outlined"
                      required
                      placeholder="****"
                      value={formDetails.exam_pin}
                      onChange={(e) =>
                        handleFormChange(
                          "exam_pin",
                          sanitizeInput(e.target.value, "Pincode"),
                        )
                      }
                      inputProps={{ maxLength: 4 }}
                      error={
                        formDetails.exam_pin?.length > 0 &&
                        formDetails.exam_pin.length !== 4
                      }
                      helperText={
                        formDetails.exam_pin?.length > 0 &&
                          formDetails.exam_pin.length !== 4
                          ? "Must be 4 digits"
                          : ""
                      }
                      style={{ flex: 1 }}
                    />
                    <Button
                      onClick={handleAutoGeneratePin}
                      className={classes.custombtnblue}
                      disabled={loading}
                      style={{
                        whiteSpace: "nowrap",
                        height: "40px",
                        padding: "0 10px",
                        fontSize: "12px",
                        minWidth: "auto",
                      }}
                    >
                      {loading ? "..." : "Generate"}
                    </Button>
                  </div>
                ) : (
                  <TextField
                    type="text"
                    variant="outlined"
                    disabled
                    placeholder="PIN Disabled"
                    value=""
                  />
                )}
              </div>
            </div>

            {/* Row 4 (IP MAT): Exam Direction | Subject Selection Before Exam Start | Submission lock */}
            {formDetails.exam_template === "ipmat" && (
              <>
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Exam Direction <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="exam-direction-label"
                      id="exam-direction"
                      value={formDetails.direction}
                      onChange={(e) =>
                        handleFormChange("direction", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect} style={{ opacity: 0.4 }}>
                          Select Here
                        </em>
                      </MenuItem>
                      <MenuItem value={"unidirectional"}>Unidirectional</MenuItem>
                      <MenuItem value={"bidirectional"}>Bidirectional</MenuItem>
                    </Select>
                  </div>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Subject Selection Before Exam Start <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="exam-section-selection-label"
                      id="exam-section-selection"
                      value={formDetails.subject_selection}
                      onChange={(e) =>
                        handleFormChange("subject_selection", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect} style={{ opacity: 0.4 }}>
                          Select Here
                        </em>
                      </MenuItem>
                      <MenuItem value={"yes"}>Yes</MenuItem>
                      <MenuItem value={"no"}>No</MenuItem>
                    </Select>
                  </div>

                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Submission lock <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <Select
                      labelId="submission-lock-label"
                      id="submission-lock"
                      value={formDetails.is_submit_on_time}
                      onChange={(e) =>
                        handleFormChange("is_submit_on_time", e.target.value)
                      }
                      displayEmpty
                      className={classes.selectEmpty}
                      MenuProps={menuProps}
                      variant="outlined"
                    >
                      <MenuItem disabled value="">
                        <em className={classes.defaultselect}>Select Here</em>
                      </MenuItem>
                      <MenuItem value={"no"}>Yes</MenuItem>
                      <MenuItem value={"yes"}>No</MenuItem>
                    </Select>
                  </div>
                </div>

                {/* Row 5 (IP MAT): Subject Wise Submit */}
                <div
                  className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
                >
                  <Typography
                    className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                    variant="h6"
                    display="inline"
                  ></Typography>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  >
                    <input
                      type="hidden"
                      name="subject_wise"
                      value={showSubjectWiseDuration}
                    />
                    {/* <FormLabel
                      className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                    >
                      Subject Wise Submit{" "}
                      <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <RadioGroup
                      className={`${classes.radiocolor}`}
                      row
                      aria-label="Question Mark System"
                      name="Question Mark System"
                      value={showSubjectWiseDuration}
                      onChange={handleQuestionMarkSystemChange}
                      disabled
                    >
                      <FormControlLabel
                        value="no"
                        control={<Radio disabled />}
                        label="No"
                      />
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Yes"
                      />
                    </RadioGroup> */}
                  </div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  ></div>
                  <div
                    className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
                  ></div>
                </div>
              </>
            )}
          </div>

          {/* ── Section 3: Instructions ── */}
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Instructions
              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
              >
                {formDetails.language.map((lang) => (
                  <div key={lang}>
                    <FormLabel>
                      {/* Enter your Genral Instructions for {lang} language: */}
                      Enter your Exam Instructions for {lang} language:
                    </FormLabel>
                    <ReactQuill
                      style={{
                        height: "500px",
                        paddingTop: "1rem",
                        paddingBottom: "3rem",
                      }}
                      value={formDetails.genral_instruction[lang]}
                      onChange={(content) => {
                        setFormDetails((prev) => ({
                          ...prev,
                          genral_instruction: {
                            ...prev.genral_instruction,
                            [lang]: content,
                          },
                        }));
                      }}
                      modules={quillModules}
                      formats={quillFormats}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.mt2}  ${classes.justifyspacebetween} ${classes.mt1} `}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w75}`}
              >
                {formDetails.language.map((lang) => (
                  <div key={lang}>
                    <FormLabel>
                      {/* Enter your Exam Instructions for {lang} language: */}
                      Enter your Genral Instructions for {lang} language:
                    </FormLabel>
                    <ReactQuill
                      // readOnly
                      value={formDetails.exam_instructions[lang]}
                      onChange={(content) => {
                        setFormDetails((prev) => ({
                          ...prev,
                          exam_instructions: {
                            ...prev.exam_instructions,
                            [lang]: content,
                          },
                        }));
                      }}
                      // readOnly={true}
                      modules={quillModules}
                      // modules={{
                      //   ...quillModules,
                      //   toolbar: {
                      //     ...quillModules.toolbar,
                      //     container: quillModules.toolbar?.container,
                      //     handlers: {}, // override all handlers so nothing works
                      //   },
                      // }}
                      formats={quillFormats}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                *Other Details
              </Typography>

              {/* ipmat: 4 fields in one row with w24 */}
              {formDetails.exam_template === "ipmat" ? (
                <>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Duration in minutes <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      required
                      value={formDetails.duration}
                      onChange={(e) => handleFormChange("duration", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Start Date <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="date"
                      variant="outlined"
                      required
                      value={formDetails.start_date}
                      onChange={(e) => handleFormChange("start_date", e.target.value)}
                      placeholder="Select Date"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Start Time <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="time"
                      variant="outlined"
                      required
                      value={formDetails.start_time}
                      onChange={(e) => handleFormChange("start_time", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      End Time <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="time"
                      variant="outlined"
                      required
                      value={formDetails.end_time}
                      onChange={(e) => handleFormChange("end_time", e.target.value)}
                      placeholder="Type Here"
                      disabled={formDetails.time_bound === "yes"}
                      inputProps={{
                        min: formDetails.start_time || undefined,
                      }}
                    />
                  </div>
                </>
              ) : (
                /* non-ipmat: original 5-field layout */
                <>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Duration in minutes <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      required
                      value={formDetails.duration}
                      onChange={(e) => handleFormChange("duration", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Enable submit in minutes{" "}
                    </FormLabel>
                    <TextField
                      type="number"
                      variant="outlined"
                      required
                      value={formDetails.enable_submit}
                      onChange={(e) => handleFormChange("enable_submit", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Start Date <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="date"
                      variant="outlined"
                      required
                      value={formDetails.start_date}
                      onChange={(e) => handleFormChange("start_date", e.target.value)}
                      placeholder="Select Date"
                    />
                  </div>
                  <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                    <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                      Start Time <span className={classes.textcolorred}>*</span>
                    </FormLabel>
                    <TextField
                      type="time"
                      variant="outlined"
                      required
                      value={formDetails.start_time}
                      onChange={(e) => handleFormChange("start_time", e.target.value)}
                      placeholder="Type Here"
                    />
                  </div>
                </>
              )}
            </div>

            {/* End Time row — only for non-ipmat (ipmat has it in row above) */}
            {formDetails.exam_template !== "ipmat" && (
              <div className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}>
                <Typography
                  className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                  variant="h6"
                  display="inline"
                ></Typography>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}>
                  <FormLabel className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}>
                    End Time <span className={classes.textcolorred}>*</span>
                  </FormLabel>
                  <TextField
                    type="time"
                    variant="outlined"
                    required
                    value={formDetails.end_time}
                    onChange={(e) => handleFormChange("end_time", e.target.value)}
                    placeholder="Type Here"
                    disabled={formDetails.time_bound === "yes"}
                    inputProps={{
                      min: formDetails.start_time || undefined,
                    }}
                  />
                </div>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}></div>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}></div>
                <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}></div>
              </div>
            )}

            {/* <div className={`${classes.dflex} ${classes.justifyspacebetween}`}>
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w18}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit} ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Select Slot <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  value={formDetails.slot_value}
                  onChange={(e) =>
                    handleFormChange("slot_value", e.target.value)
                  }
                  displayEmpty
                  required
                  variant="outlined"
                >
                  <MenuItem value="" disabled>
                    Select a slot
                  </MenuItem>
                  {slotDropdownFieldData?.centers_slot?.map((slot, index) => (
                    <MenuItem key={index} value={slot?.id}>
                      {slot?.slot_name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
            </div> */}
          </div>

          {formDetails.randomized_question_pick === "yes" &&
            (formDetails.exam_template === "ssc/railway" ||
              formDetails.exam_template === "ipmat") && (
              <QuestionPickTable
                classes={classes}
                formDetails={formDetails}
                handleFormChange={handleFormChange}
                selectedSubject={selectedSubject}
                setSelectedSubjectSLength={setSelectedSubjectSLength}
              />
            )}
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              onClick={handleCancel}
              className={`${classes.custombtnoutline}`}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddExamForm;
